import { render, staticRenderFns } from "./DashboardEventsSalesInvoices.vue?vue&type=template&id=7f2cf779&scoped=true"
import script from "./DashboardEventsSalesInvoices.vue?vue&type=script&lang=js"
export * from "./DashboardEventsSalesInvoices.vue?vue&type=script&lang=js"
import style0 from "./DashboardEventsSalesInvoices.vue?vue&type=style&index=0&id=7f2cf779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2cf779",
  null
  
)

export default component.exports